import {GridList} from 'shells/grid-list/grid-list';
import {StatCard} from 'shells/metrics/stat-card/stat-card';

import type {
    GetChatbotReport_chatbotReport_dbMetrics as DbMetrics,
    GetChatbotReport_chatbotReport_aiMetrics as AiMetrics,
} from 'nutshell-graphql-types';

import {VISITORS_TOOLTIP} from '../engagement/consts';
import {getTooltip} from '../engagement/helpers';
interface Props {
    dbMetrics: DbMetrics;
    aiMetrics: AiMetrics;
}

export function ChatbotStatsGrid(props: Props) {
    return (
        <GridList numColumns={4}>
            <StatCard
                displayName='Total visitors'
                value={props.dbMetrics.visitorCount.toLocaleString()}
                type='text'
                tooltipInfo={getTooltip(VISITORS_TOOLTIP.description, VISITORS_TOOLTIP.example)}
                tooltipBodyColor='dark'
            />
            <StatCard
                displayName='Chatbot conversations'
                value={props.dbMetrics.conversationCount.toLocaleString()}
                type='text'
            />
            <StatCard
                displayName='% asking for a human'
                value={props.aiMetrics.askedForHumanPercent.toLocaleString()}
                type='percent'
            />
            <StatCard
                displayName='% chats filled out a form'
                value={props.dbMetrics.visitorsFilledFormPercent.toLocaleString()}
                type='percent'
                tooltipInfo='% of chat conversations where a visitor filled out a form (Booking, Email, Quote, etc.)'
                tooltipBodyColor='dark'
            />
        </GridList>
    );
}
